






























































































































































































































































































































































































































































































































































































































































































































































































































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeOrcamentoStore from '@/components/Backoffice/Store/BackofficeOrcamentoStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'

import { timeout, humanTime, displayColorBySituation, displayColorByStatus, verifyEtapaOrcamento, timeoutDefault, groupCollectionByField, maskHour, lembreteColor, getHospitalAreaName, backofficeRoute } from '@/utils/common'
import { StatusSlaEnum, IRequestMessage, RequestMessage, Loading, LembreteEnum, AgendamentoCirurgia, Solicitacao, SituacaoEnum, AgendamentoSolicitacaoItem, OrcamentoAcaoEnum, User, TipoDocumentoUpload, PendenciaMensagem, TipoMensagemEnum } from '@/types/_'
import { PendenciaSolicitacao, Orcamento, Agendamento } from '@/types/core'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'
import { backofficeSharedDataService } from '@/components/Backoffice/Store/backoffice-shared-data-service'
import Chat from '@/views/backoffice-chat/chat/chat.vue'
import BackofficeModalChatStore from '@/views/backoffice-chat/store/backoffice-modal-chat-store'
import AgendamentoApi from '@/Apis/Agendamento/Agendamento'

@Component({
  filters: { humanTime },
  components: {
    Chat,
  },
})

export default class ViewBackofficeOrcamento extends Vue {
  hTime(s: string) {
    return humanTime(s)
  }

  displayDataAgendamento(item: any) {
    if (item.situacao.key === 'Cancelada') return 'Sem previsão'
    if (item.situacaoData.key === 'NovaDataSolicitada') return 'Nova data solicitada'
    if (item.situacaoData.key === 'SemData') return 'Sem data definida'
    if (item.dataAgendamentoVirtual) return 'Data virtual'
    if (item.dataAgendamento) return this.hTime(item.dataAgendamento)
    if (item.opcaoDataPrevisto1) return this.hTime(item.opcaoDataPrevisto1)
    return 'Sem previsão'
  }

  formatDataAgendamento(item: any) {
    if (item.situacao.key === 'Cancelada') return 'bold__text--grey'
    if (item.situacaoData.key === 'NovaDataSolicitada') return 'bold__text--orange'
    if (item.situacaoData.key === 'SemData') return 'bold__text--light-grey'
    if (item.dataAgendamentoVirtual) return 'bold__text--yellow'
    if (item.dataAgendamento) return 'bold__text--grey'
    if (item.opcaoDataPrevisto1) return 'bold__text--red'
    return 'bold__text--grey'
  }

  $user: User;

  readyState: boolean = false
  loadVisualizar: string = ''
  loadVisualizarDrillDown: boolean = false
  loadHistorico: string = ''
  loadComentario: string = ''
  loadUpload: boolean = false
  modalAnexo: boolean = false
  loadModalOrcamento: string = ''
  loadModalOrcamentoParticular: string = ''
  loadModalGerarCobranca: string = ''
  loadModalInformarPagamento: string = ''
  loadModalMensagemMedico: string = ''
  solicitacaoId: string = ''
  loadDeleteAnexo: string = ''
  loadVoltarStatus: string = ''
  loadVoltarAnexo: boolean = false

  files: any[] = []

  expand: boolean = false
  headers: any[] = [
    { text: '', value: '', sortable: false, active: true },
    { text: 'Paciente', value: 'pacienteNome', sortable: false, active: true },
    { text: 'Médico', value: 'medicoNome', sortable: false, active: true },
    { text: 'Caráter', value: 'carater', sortable: false, active: true },
    { text: 'Item particular', value: 'temItemParticular', sortable: false, active: true },
    { text: 'Situação', value: 'situacao', sortable: false, active: true },
    { text: 'SLA', value: 'statusSla', sortable: false, active: true },
    { text: 'Ações', value: 'acoes', sortable: false, active: true, width: '157.41px' },
    { text: 'Data da cirurgia', value: 'dataAgendamento', sortable: false, active: true },
    { text: '', value: '', sortable: false, active: true },
  ]

  getRequestMessage: IRequestMessage = new RequestMessage()
  areaDoHospital: any = getHospitalAreaName()

  loadingReq: Loading = {
    status: false,
    text: '',
  }

  up: boolean = false
  orcamento: Orcamento.IOrcamento = new Orcamento.Orcamento()

  loadingAlterarOrcamento = false

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get backofficeModalChatStore() {
    return getModule(BackofficeModalChatStore, this.$store)
  }

  async openChat(surgerySolicitationData: any) {
    const chatData = {
      solicitationId: surgerySolicitationData.id,
      chatArea: 'orcamento',
      recipientName: surgerySolicitationData.medicoNome,
      senderId: this.$user.profile.sub,
      senderName: this.$user.profile.name,
    }

    this.backofficeModalChatStore.reset()
    await this.backofficeModalChatStore.openChatModal(chatData)

    this.ga('backoffice-chat', 'abrir-chat')
  }

  get getBackofficeOrcamentoStore() {
    return getModule(BackofficeOrcamentoStore, this.$store)
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get loadingVoltarStatus() {
    return this.loadVoltarStatus
  }

  set loadingVoltarStatus(value: string) {
    this.loadVoltarStatus = value
  }

  get loadingVoltarAnexo() {
    return this.loadVoltarAnexo
  }

  set loadingVoltarAnexo(value: boolean) {
    this.loadVoltarAnexo = value
  }

  get loadingDeleteAnexo() {
    return this.loadDeleteAnexo
  }

  set loadingDeleteAnexo(value: string) {
    this.loadDeleteAnexo = value
  }

  get uploading() {
    return this.up
  }

  set uploading(value: boolean) {
    this.up = value
  }

  get showModalAnexo() {
    return this.modalAnexo
  }

  set showModalAnexo(value: boolean) {
    this.modalAnexo = value
  }

  get loadingModalOrcamento() {
    return this.loadModalOrcamento
  }

  set loadingModalOrcamento(value: string) {
    this.loadModalOrcamento = value
  }

  get loadingModalOrcamentoParticular() {
    return this.loadModalOrcamentoParticular
  }

  set loadingModalOrcamentoParticular(value: string) {
    this.loadModalOrcamentoParticular = value
  }

  get loadingModalGerarCobranca() {
    return this.loadModalGerarCobranca
  }

  set loadingModalGerarCobranca(value: string) {
    this.loadModalGerarCobranca = value
  }

  get loadingModalInformarPagamento() {
    return this.loadModalInformarPagamento
  }

  set loadingModalInformarPagamento(value: string) {
    this.loadModalInformarPagamento = value
  }

  get loadingMensagemMedico() {
    return this.loadModalMensagemMedico
  }

  set loadingMensagemMedico(value: string) {
    this.loadModalMensagemMedico = value
  }

  get loadingComentario() {
    return this.loadComentario
  }

  set loadingComentario(value: string) {
    this.loadComentario = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: string) {
    this.loadHistorico = value
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get loadingVisualizar() {
    return this.loadVisualizar
  }

  set loadingVisualizar(val: string) {
    this.loadVisualizar = val
  }

  get loadingVisualizarDrillDown() {
    return this.loadVisualizarDrillDown
  }

  set loadingVisualizarDrillDown(val: boolean) {
    this.loadVisualizarDrillDown = val
  }

  get loadingRequest() {
    return this.loadingReq
  }

  set loadingRequest(value: Loading) {
    this.loadingReq = value
  }

  async closeModalAnexo() {
    this.loadingVoltarAnexo = true
    await timeoutDefault()
    this.getBackofficeOrcamentoStore.clearAnexo()
    await this.getBackofficeOrcamentoStore.loadAgendamentosMedicoSearch()
    this.solicitacaoId = ''
    this.modalAnexo = false
    this.loadingVoltarAnexo = false
  }

  async deleteAnexo(value) {
    this.loadingDeleteAnexo = value.identifier

    const request = await this.getBackofficeOrcamentoStore.deleteLaudo({
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      id: value.identifier,
    })

    if (request.success) {
      if (request.success) {
        const removeArray: any[] = []

        for (let i = 0; i < this.getLaudos.length; i++) {
          if (this.getLaudos[i].identifier === value.identifier) {
            removeArray.push(i)
          }
        }

        for (let i = 0; i < removeArray.length; i++) {
          this.getLaudos.splice(removeArray[i], 1)
        }
      }
    }
    this.loadingDeleteAnexo = ''
  }

  columnSelectionMenu: boolean = false

  hasActiveHeader(value: string) {
    if (value === '') return true
    return this.headers.find(header => header.value === value).active
  }

  getTableHeaders() {
    const headers = localStorage.getItem('backoffice-orcamento-table-headers')
    this.headers = headers ? JSON.parse(headers) : this.headers
  }

  saveHeaders() {
    (localStorage as any).setItem('backoffice-orcamento-table-headers', JSON.stringify(this.headers, null, 2))
  }

  async init() {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.getBackofficeOrcamentoStore.clearSolicitacoes()
    this.getBackofficeOrcamentoStore.clearFiltro()
    this.getBackofficeOrcamentoStore.setFilterOn(false)
    this.getBackofficeOrcamentoStore.clearSituacoes()
    this.getBackofficeOrcamentoStore.setSituacoes(SituacaoEnum.AguardandoOrcamento)
    this.getBackofficeOrcamentoStore.setEtapa('orcamento')

    this.de = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')

    await this.getBackofficeOrcamentoStore.loadAgendamentosMedicoSearch()
    this.clearLoadingRequest()
  }

  displayReserva(item: any) {
    if (item.situacaoData.key === 'SemData') return 'Sem data definida'
    return item.numeroAgendamento || 'Sem reserva'
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loadingRequest = { status, text }
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  get solicitacoes() {
    return this.getBackofficeOrcamentoStore.solicitacoes
  }

  get drawer() {
    return this.getBackofficeOrcamentoStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getBackofficeOrcamentoStore.setFilterDrawer(value)
  }

  get hospitalFazOrcamentoParticularAvulso() {
    return this.getBackofficeOrcamentoStore.hospitais.some((h: any) => h.hospitalFazOrcamentoParticularAvulso)
  }

  get etapa() {
    return this.getBackofficeOrcamentoStore.situacoes
  }

  set etapa(value: any) {
    this.getBackofficeOrcamentoStore.setSituacoes(value.key)
  }

  get etapas() {
    return [
      { key: 'AguardandoOrcamento', display: 'Aguardando orçamento', quantidade: this.getAguardandoOrcamentoTotal },
      { key: 'NovoOrcamentoParticular', display: 'Novo orçamento particular', quantidade: this.getNovoOrcamentoParticularTotal },
      { key: 'AguardandoAprovacaoOrcamento', display: 'Aguardando aprovação', quantidade: this.getAguardandoAprovacaoOrcamentoTotal },
      ...this.hospitalFazOrcamentoParticularAvulso ? [{ key: 'AguardandoOrcamentoParticularAvulso', display: 'Aguardando Orçamento Avulso', quantidade: this.getAguardandoOrcamentoParticularAvulsoTotal }] : [],
      ...this.hospitalFazOrcamentoParticularAvulso ? [{ key: 'OrcamentoParticularAvulsoEnviado', display: 'Orçamento Avulso Enviado', quantidade: this.getOrcamentoParticularAvulsoEnviadoTotal }] : [],
      { key: 'OrcamentoAprovado', display: 'Orçamento aprovado', quantidade: this.getOrcamentoAprovadoTotal },
      { key: 'OrcamentoRecusado', display: 'Orçamento recusado', quantidade: this.getOrcamentoRecusadoTotal },
      { key: 'AguardandoGeracaoDaCobranca', display: 'Aguardando geração da cobrança', quantidade: this.getAguardandoGeracaoDaCobrancaTotal },
      { key: 'AguardandoPagamento', display: 'Aguardando pagamento', quantidade: this.getAguardandoPagamentoTotal },
      { key: 'OrcamentoCancelado', display: 'Orçamento cancelado', quantidade: this.getOrcamentoCanceladoTotal },
      { key: 'Pendente', display: 'Pendência médica', quantidade: this.getPendenteTotal },
      { key: 'PendenciaRespondida', display: 'Pendência respondida', quantidade: this.getPendenciaRespondidaTotal },
    ]
  }

  get getAllEtapas() {
    return this.etapa.length === this.etapas.length
  }

  get getSomeEtapas() {
    return this.etapa.length > 0 && !this.getAllEtapas
  }

  get icon() {
    if (this.getAllEtapas) return 'mdi-checkbox-marked'
    if (this.getSomeEtapas) return 'mdi-minus-box'
    return 'mdi-checkbox-blank-outline'
  }

  get getLaudos() {
    return this.getBackofficeOrcamentoStore.anexo
  }

  set getLaudos(value: any) {
    this.getBackofficeOrcamentoStore.setAnexo(value)
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  get todosOsStatus() {
    return this.getBackofficeOrcamentoStore.todosOsStatus
  }

  set todosOsStatus(value: boolean) {
    this.getBackofficeOrcamentoStore.setTodosOsStatus(value)
  }

  get todosOsStatusDaArea() {
    return this.getBackofficeOrcamentoStore.todosOsStatusDaArea
  }

  set todosOsStatusDaArea(value: boolean) {
    this.getBackofficeOrcamentoStore.setTodosOsStatusDaArea(value)
  }

  get iconTodosOsStatus() {
    return this.todosOsStatus ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
  }

  get iconTodosOsStatusDaArea() {
    return this.todosOsStatusDaArea ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
  }

  modDe: boolean = false

  get de() {
    return this.getBackofficeOrcamentoStore.deFiltro
  }

  set de(value: Date | string | null) {
    this.getBackofficeOrcamentoStore.setDeFiltro(value)
  }

  get formattedDe() {
    return this.formatDateRange(this.de)
  }

  get modalDe() {
    return this.modDe
  }

  set modalDe(value: boolean) {
    this.modDe = value
  }

  formatDateRange(date: Date | string | null) {
    if (!date) return null
    const [year, month, day] = date.toString().split('-')
    return `${day}/${month}/${year}`
  }

  resetModalDe() {
    this.de = null
    this.modalDe = false
  }

  minDate(date: string) {
    if (!date) return null
    const min = moment(date).add(1, 'day').format('YYYY-MM-DD')
    return min
  }

  maxDate(date: string) {
    if (!date) return null
    const max = moment(date).add(1, 'year').format('YYYY-MM-DD')
    return max
  }

  clearDate(field: string) {
    if (field === 'de') {
      this.de = null
    }
  }

  selectAllFromHospital() {
    this.$nextTick(() => {
      this.todosOsStatus = !this.todosOsStatus
    })
  }

  selectAllFromArea() {
    this.$nextTick(() => {
      this.todosOsStatusDaArea = !this.todosOsStatusDaArea
    })
  }

  selectSituacao(item: any) {
    if (this.todosOsStatus || this.todosOsStatusDaArea) {
      this.todosOsStatus = false
      this.todosOsStatusDaArea = false
      this.getBackofficeOrcamentoStore.clearSituacoes()
    }
    this.etapa = item
  }

  async filterSituacao() {
    if (!this.de) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Preencha o campo de Data de início do período', icon: 'warning', color: '#C62828' })
      return
    }
    this.getBackofficeOrcamentoStore.clearPagePagination()
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    await this.getBackofficeOrcamentoStore.loadAgendamentosMedicoSearch()
    this.clearLoadingRequest()
  }

  get getAguardandoOrcamentoTotal() {
    if (this.getBackofficeOrcamentoStore.situacoesCounter.length > 0
      && this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoOrcamento).length > 0) {
      return this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoOrcamento)[0].quantidade
    }
    return 0
  }

  get getNovoOrcamentoParticularTotal() {
    if (this.getBackofficeOrcamentoStore.situacoesCounter.length > 0
      && this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.NovoOrcamentoParticular).length > 0) {
      return this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.NovoOrcamentoParticular)[0].quantidade
    }
    return 0
  }

  get getAguardandoAprovacaoOrcamentoTotal() {
    if (this.getBackofficeOrcamentoStore.situacoesCounter.length > 0
      && this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoAprovacaoOrcamento).length > 0) {
      return this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoAprovacaoOrcamento)[0].quantidade
    }
    return 0
  }

  get getAguardandoOrcamentoParticularAvulsoTotal() {
    if (this.getBackofficeOrcamentoStore.situacoesCounter.length > 0
      && this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoOrcamentoParticularAvulso).length > 0) {
      return this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoOrcamentoParticularAvulso)[0].quantidade
    }
    return 0
  }

  get getOrcamentoParticularAvulsoEnviadoTotal() {
    if (this.getBackofficeOrcamentoStore.situacoesCounter.length > 0
      && this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.OrcamentoParticularAvulsoEnviado).length > 0) {
      return this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.OrcamentoParticularAvulsoEnviado)[0].quantidade
    }
    return 0
  }

  get getOrcamentoAprovadoTotal() {
    if (this.getBackofficeOrcamentoStore.situacoesCounter.length > 0
      && this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.OrcamentoAprovado).length > 0) {
      return this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.OrcamentoAprovado)[0].quantidade
    }
    return 0
  }

  get getOrcamentoRecusadoTotal() {
    if (this.getBackofficeOrcamentoStore.situacoesCounter.length > 0
      && this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.OrcamentoRecusado).length > 0) {
      return this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.OrcamentoRecusado)[0].quantidade
    }
    return 0
  }

  get getAguardandoGeracaoDaCobrancaTotal() {
    if (this.getBackofficeOrcamentoStore.situacoesCounter.length > 0
      && this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoGeracaoDaCobranca).length > 0) {
      return this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoGeracaoDaCobranca)[0].quantidade
    }
    return 0
  }

  get getAguardandoPagamentoTotal() {
    if (this.getBackofficeOrcamentoStore.situacoesCounter.length > 0
      && this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoPagamento).length > 0) {
      return this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoPagamento)[0].quantidade
    }
    return 0
  }

  get getOrcamentoCanceladoTotal() {
    if (this.getBackofficeOrcamentoStore.situacoesCounter.length > 0
      && this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.OrcamentoCancelado).length > 0) {
      return this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.OrcamentoCancelado)[0].quantidade
    }
    return 0
  }

  get getPendenteTotal() {
    if (this.getBackofficeOrcamentoStore.situacoesCounter.length > 0
      && this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Pendente).length > 0) {
      return this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Pendente)[0].quantidade
    }
    return 0
  }

  get getPendenciaRespondidaTotal() {
    if (this.getBackofficeOrcamentoStore.situacoesCounter.some(c => c.key === SituacaoEnum.PendenciaRespondida
      && this.getBackofficeOrcamentoStore.situacoesCounter.filter(d => d.key === SituacaoEnum.PendenciaRespondida).length > 0)) {
      return this.getBackofficeOrcamentoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.PendenciaRespondida)[0].quantidade
    }
    return 0
  }

  get getTotal() {
    return this.getBackofficeOrcamentoStore.totalSolicitacoes || 0
  }

  verifyEtapa(item: any) {
    return verifyEtapaOrcamento(item)
  }

  showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  getColor(status: string) {
    switch (status) {
      case 'Apto':
        return { color: 'green darken-2', icon: 'thumb_up', tooltip: 'Paciente apto para cirurgia' }
      case 'AptoComAtencao':
        return { color: 'yellow darken-3', icon: 'thumb_up', tooltip: 'Verificar alterações feitas pelo anestesista' }
      case 'NaoApto':
        return { color: 'red darken-3', icon: 'thumb_down', tooltip: 'Paciente não está apto para cirurgia' }
      default:
        return { color: 'orange darken-4', icon: 'schedule', tooltip: 'Avaliação pré-anestésica pendente' }
    }
  }

  getTableRowClasses(data: AgendamentoSolicitacaoItem) {
    const classes: string[] = []

    if (data.jaPassouPorEsteStatus) {
      classes.push('backoffice-list-table-row__japassouporessestatus')
    }

    if (data.carater.key === 'Urgencia') {
      classes.push('backoffice-list-table-row__urgencia')
    }

    if (data.auditada && this.$user.profile.roles.includes('auditoria') && ['BackofficeAutorizacao', 'BackofficeAgendamento'].includes(this.$route.name!)) {
      classes.push('backoffice-list-table-row__auditada')
    }

    return classes
  }

  async clearAdvancedFilters() {
    this.getBackofficeOrcamentoStore.clearFiltro()
    this.getBackofficeOrcamentoStore.setFilterOn(false)
    this.drawer = false
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)

    this.de = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')
    this.clearLoadingRequest()
  }

  displayCorSituacao(value: string) {
    return displayColorBySituation(value)
  }

  displayCorEtapa(value: string) {
    return displayColorByStatus(value)
  }

  slaColor(statusSla: StatusSlaEnum) {
    switch (statusSla) {
      case StatusSlaEnum.Normal:
        return 'green'

      case StatusSlaEnum.Alerta:
        return 'yellow'

      case StatusSlaEnum.Critico:
        return 'red'

      default:
        return ''
    }
  }

  async showHistory(solicitacaoId: string) {
    this.loadingHistorico = solicitacaoId
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = ''
  }

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  async showComentario(solicitacaoId: string) {
    this.loadingComentario = solicitacaoId
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.loadingComentario = ''
  }

  lembreteColorDisplay(lembrete: LembreteEnum) {
    return lembreteColor(lembrete)
  }

  get getPagina() {
    return this.getBackofficeOrcamentoStore.pagina
  }

  set getPagina(value: number) {
    this.getBackofficeOrcamentoStore.setPagina(value)
  }

  get getQtdPorPagina() {
    return this.getBackofficeOrcamentoStore.qtdPorPagina
  }

  set getQtdPorPagina(value: number) {
    this.getBackofficeOrcamentoStore.setQtdPorPagina(value)
  }

  get getTotalSolicitacoes() {
    return this.getBackofficeOrcamentoStore.totalSolicitacoes
  }

  get agendamentoLength() {
    return Math.ceil(this.getTotalSolicitacoes / this.getQtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  async getResults(pagina: number) {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.getPagina = pagina
    await this.getBackofficeOrcamentoStore.loadAgendamentosMedicoSearch()
    this.clearLoadingRequest()
  }

  async mounted() {
    await this.init()
    this.readyState = true
    this.getTableHeaders() // Carrega as colunas da tabela
    EventBus.$on('setLembrete', value => this.getBackofficeOrcamentoStore.setLembreteStatus(value))
  }

  async showModalVisualizar(agendamentoCirurgia: AgendamentoCirurgia) {
    this.getBackofficeGlobalStore.setHospitalId(agendamentoCirurgia.hospitalId)
    this.loadingVisualizar = agendamentoCirurgia.id

    this.getBackofficeGlobalStore.setBackofficeArea(backofficeRoute())
    this.getBackofficeGlobalStore.setSolicitacaoId(agendamentoCirurgia.id)
    this.getBackofficeGlobalStore.setModal({ name: 'visualizacao', value: true })

    this.ga('backoffice-suprimentos', 'visualizar-aguardando-cotacao')
    this.loadingVisualizar = ''
  }

  loadCancelamento: string = ''
  get loadingCancelamento() { return this.loadCancelamento }
  set loadingCancelamento(value: string) { this.loadCancelamento = value }

  loadCancelarOrcamentoParticular: boolean = false
  get loadingCancelarOrcamentoParticular() { return this.loadCancelarOrcamentoParticular }
  set loadingCancelarOrcamentoParticular(value: boolean) { this.loadCancelarOrcamentoParticular = value }

  async handleAlterarOrcamento(item: any) {
    this.loadingAlterarOrcamento = true

    const { hospitalId, convenioId, planoId, id } = item
    const agd = new Agendamento.Agendamento()

    const response = await agd.bloquearSolicitacao(id)
    if (response.success) {
      await this.getBackofficeGlobalStore.getHospitalTemplate(hospitalId)
      const request = await this.getBackofficeGlobalStore.getSolicitacaoAlteradaById(id)
      if (request.success) {
        backofficeSharedDataService.solicitacaoAlterada = this.getBackofficeGlobalStore.solicitacaoAlterada

        await Promise.all([
          this.getBackofficeGlobalStore.getAllHospitais(),
          this.getBackofficeGlobalStore.getProcedimentosBackofficeSearch(''),
          this.getBackofficeGlobalStore.getAllConvenios(hospitalId),
          this.getBackofficeGlobalStore.getAllPlanos({ hospitalId, convenioId }),
          this.getBackofficeGlobalStore.getAllCategoriasByPlano({ hospitalId, convenioId, planoId }),
          this.getBackofficeGlobalStore.getReservaHemocomponente(),
          backofficeSharedDataService.loadMaterialOptions(),
          backofficeSharedDataService.loadFornecedorOptions(),
        ])

        if (this.getBackofficeGlobalStore.solicitacaoAlterada.hospital.utilizaTipoAcomodacaoHospital) {
          await this.getBackofficeGlobalStore.getAllTipoAcomodacao(hospitalId)
        }

        this.getBackofficeGlobalStore.setModal({ name: 'alterarSolicitacao', value: true })
        this.ga('backoffice-agendamento', 'abrir-modal-alterar-solicitacao')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro ao obter a solicitação.', icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingAlterarOrcamento = false
  }

  async showModalCancelarOrcamento(orcamento: any) {
    this.loadingCancelamento = orcamento.id
    const request = await this.getBackofficeOrcamentoStore.getMotivosCancelamentoAll(orcamento.hospitalId)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: request.message ? `${request.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao buscar motivos de cancelamento ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingCancelamento = ''
      return
    }
    this.getBackofficeOrcamentoStore.setOrcamentoId(orcamento.id)
    this.getBackofficeOrcamentoStore.setShowModalCancelamento(true)
    this.loadingCancelamento = ''
  }

  async analisarOrcamentoParticular(agendamentoCirurgia: AgendamentoSolicitacaoItem) {
    this.loadingModalOrcamentoParticular = agendamentoCirurgia.id

    let response = await this.getBackofficeGlobalStore.bloquearSolicitacao(agendamentoCirurgia.id)
    if (response.success) {
      await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
      response = await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoCirurgia.id)
      if (response.success) {
        this.getBackofficeGlobalStore.setModal({ name: 'orcamentoParticular', value: true })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingModalOrcamentoParticular = ''
  }

  async enviarMensagemMedico(agendamentoCirurgia: AgendamentoCirurgia) {
    try {
      this.loadingMensagemMedico = agendamentoCirurgia.id

      const response = await AgendamentoApi.AgendamentoMedicoBackofficeApi.enviarNotificacaoWhatsapp(agendamentoCirurgia.id, {
        etapaDeNotificacao: 'AguardandoAprovacaoOrcamento',
      })

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Mensagem enviada ao médico com sucesso', icon: 'check_circle', color: '#43A047' })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro ao enviar mensagem ao médico', icon: 'warning', color: '#C62828' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao enviar mensagem ao médico', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingMensagemMedico = ''
    }
  }

  async gerarCobranca(agendamentoCirurgia: AgendamentoSolicitacaoItem) {
    this.loadingModalGerarCobranca = agendamentoCirurgia.id

    let response = await this.getBackofficeGlobalStore.bloquearSolicitacao(agendamentoCirurgia.id)
    if (response.success) {
      await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
      response = await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoCirurgia.id)
      if (response.success) {
        this.getBackofficeGlobalStore.setModal({ name: 'gerarCobranca', value: true })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingModalGerarCobranca = ''
  }

  async informarPagamento(agendamentoCirurgia: AgendamentoSolicitacaoItem) {
    this.loadingModalInformarPagamento = agendamentoCirurgia.id

    let response = await this.getBackofficeGlobalStore.bloquearSolicitacao(agendamentoCirurgia.id)
    if (response.success) {
      await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
      response = await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoCirurgia.id)
      if (response.success) {
        this.getBackofficeGlobalStore.setModal({ name: 'informarPagamento', value: true })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingModalInformarPagamento = ''
  }

  async enviarOrcamento(agendamentoCirurgia: AgendamentoSolicitacaoItem) {
    this.loadingModalOrcamento = agendamentoCirurgia.id

    let response = await this.getBackofficeGlobalStore.bloquearSolicitacao(agendamentoCirurgia.id)
    if (response.success) {
      await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
      response = await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoCirurgia.id)
      if (response.success) {
        await this.getBackofficeOrcamentoStore.getAllLaudos(agendamentoCirurgia.id)
        this.getBackofficeGlobalStore.setModal({ name: 'orcamento', value: true })
        this.ga('backoffice-orcamento', agendamentoCirurgia.acoes.orcamentoEnviaOrcamento ? 'enviar-orcamento' : 'atualizar-orcamento')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingModalOrcamento = ''
  }

  async showModalVoltarStatus(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingVoltarStatus = agendamentoCirurgia.id
    await timeout(500)
    this.getBackofficeGlobalStore.setAgendamentoMedicoId(agendamentoCirurgia.id)
    this.getBackofficeGlobalStore.setShowModalVoltarStatus(true)
    this.loadingVoltarStatus = ''
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  async inputFileOrcamento(newFile, oldFile) {
    this.loadingUpload = true

    if (newFile.identifier) return

    const form = new FormData()
    form.append('laudos', newFile.file)

    const header: any = {
      'Content-Type': 'multipart/form-data',
    }

    const params: any = {
      solicitacaoId: this.solicitacaoId,
      form,
      header,
    }

    const response: any = await this.getBackofficeOrcamentoStore.uploadAnexos(params)
    if (response.status === 200) {
      // eslint-disable-next-line no-param-reassign
      newFile.identifier = response.data[0].id
      // eslint-disable-next-line no-param-reassign
      newFile.url = response.data[0].url
      this.getLaudos = newFile
      this.getBackofficeOrcamentoStore.backofficeOrcamentoEnviaOrcamento({ solicitacaoId: this.solicitacaoId, acao: OrcamentoAcaoEnum.OrcamentoEnviaOrcamento })
      EventBus.$emit('setSnackbar', { show: true, text: 'Orçamento enviado com sucesso.', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro ao enviar o anexo.', icon: 'warning', color: '#C62828' })
    }

    this.loadingUpload = false
  }

  /**
   *****************************************
   * PENDENCIA
   *****************************************
   */
  $refs: { chatScrollContent: HTMLElement, cirurgiaDe: any }
  pendenciaSolicitacao: PendenciaSolicitacao.IPendenciaSolicitacao = new PendenciaSolicitacao.PendenciaSolicitacao()

  scrollToMensagem() {
    if (this.$refs.chatScrollContent) {
      setTimeout(() => {
        const elem = this.$refs.chatScrollContent

        const option: ScrollToOptions = {
          behavior: 'smooth',
          left: 0,
          top: elem.scrollHeight,
        }
        elem.scrollTo(option)
      }, 0)
    }
  }

  @Watch('showModalPendencia')
  onChangeShowModalPendencia() { this.scrollToMensagem() }

  loadRespondePendencia: string = ''
  loadClosePendencia: boolean = false
  loadEncerrarPendencia: boolean = false
  modalConfirmarEncerrarPendencia: boolean = false
  loadCloseConfirmarEncerrarPendencia: boolean = false
  loadConfirmarEncerrarPendencia: boolean = false
  modalPendencia: boolean = false
  loadMensagem: boolean = false
  mensagem: string = ''
  displayPendencia: any = {
    nomePaciente: '',
    nomeMedico: '',
  }

  get getPendenciaStore() { return getModule(SolicitacaoPendenciaStore, this.$store) }
  get getTipoMensagemEnum() { return TipoMensagemEnum }
  get getMensagens() { return this.getPendenciaStore.pendencia.mensagens }
  get getMensagem() { return this.mensagem }
  set getMensagem(texto: string) { this.mensagem = texto }
  get loadingMensagem() { return this.loadMensagem }
  set loadingMensagem(value: boolean) { this.loadMensagem = value }
  get loadingRespondePendencia() { return this.loadRespondePendencia }
  set loadingRespondePendencia(value: string) { this.loadRespondePendencia = value }
  get loadingClosePendencia() { return this.loadClosePendencia }
  set loadingClosePendencia(value: boolean) { this.loadClosePendencia = value }
  get loadingEncerrarPendencia() { return this.loadEncerrarPendencia }
  set loadingEncerrarPendencia(value: boolean) { this.loadEncerrarPendencia = value }
  get loadingCloseConfirmarEncerrarPendencia() { return this.loadCloseConfirmarEncerrarPendencia }
  set loadingCloseConfirmarEncerrarPendencia(value: boolean) { this.loadCloseConfirmarEncerrarPendencia = value }
  get loadingConfirmarEncerrarPendencia() { return this.loadConfirmarEncerrarPendencia }
  set loadingConfirmarEncerrarPendencia(value: boolean) { this.loadConfirmarEncerrarPendencia = value }
  get showModalPendencia() { return this.modalPendencia }
  set showModalPendencia(value: boolean) { this.modalPendencia = value }
  get showModalConfirmarEncerrarPendencia() { return this.modalConfirmarEncerrarPendencia }
  set showModalConfirmarEncerrarPendencia(value: boolean) { this.modalConfirmarEncerrarPendencia = value }
  get getDisplayPendencia() { return this.displayPendencia }
  set getDisplayPendencia(value: any) { this.displayPendencia = value }

  async showModalRespondePendencia(agendamentoCirurgia: AgendamentoCirurgia) {
    const solicitacaoId = agendamentoCirurgia.id
    const { hospitalId } = agendamentoCirurgia
    this.loadingRespondePendencia = solicitacaoId
    let response = await this.orcamento.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      response = await this.getPendenciaStore.getPendencias(solicitacaoId)
      if (response.success) {
        this.getDisplayPendencia = {
          nomePaciente: agendamentoCirurgia.pacienteNome,
          nomeMedico: agendamentoCirurgia.medicoNome,
        }
        this.showModalPendencia = true
        this.getBackofficeGlobalStore.setSolicitacaoId(solicitacaoId)
        this.getBackofficeGlobalStore.setHospitalId(hospitalId)
      } else {
        this.getBackofficeOrcamentoStore.deleteSolicitacao(solicitacaoId)
        await this.openFlowModal(agendamentoCirurgia)
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'done', color: '#2E7D32' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingRespondePendencia = ''
    this.ga('backoffice-orcamento', 'responder-pendencia-orcamento')
  }

  async encerrarPendencia() {
    this.loadingEncerrarPendencia = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const response = await this.pendenciaSolicitacao.encerrarPendencia(solicitacaoId)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pendência encerrada com sucesso.', icon: 'done', color: '#2E7D32' })
      this.getBackofficeOrcamentoStore.deleteSolicitacao(solicitacaoId)
      await this.openFlowModal(this.getBackofficeGlobalStore.solicitacao)
      await this.closeModalPendencia()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao encerrar a pendência.', icon: 'warning', color: '#C62828' })
    }
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeoutDefault()

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    await this.getPendenciaStore.enviarMensagem(pendenciaMensagem)
    this.getBackofficeOrcamentoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  async inputFilePendenciaOrcamento(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    let response = await this.getPendenciaStore.uploadDocumento(param)
    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      response = await this.getPendenciaStore.enviarMensagem(pendenciaMensagem)
      if (response.success) {
        this.getBackofficeOrcamentoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      }
    }

    this.loadingUpload = false
  }

  async confirmarEncerrarPendencia() {
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    this.loadingConfirmarEncerrarPendencia = true
    const response = await this.pendenciaSolicitacao.encerrarPendencia(solicitacaoId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pendência encerrada com sucesso.', icon: 'done', color: '#2E7D32' })
      await this.openFlowModal(this.getBackofficeGlobalStore.solicitacao)
      this.getBackofficeOrcamentoStore.deleteSolicitacao(solicitacaoId)
      this.closeModalPendencia()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao encerrar a pendência.', icon: 'warning', color: '#C62828' })
    }

    this.loadingConfirmarEncerrarPendencia = false
  }

  async confirmarEncerrarPendenciaCloseModal() {
    this.loadingClosePendencia = true
    await timeoutDefault()
    this.showModalConfirmarEncerrarPendencia = true
    this.loadingClosePendencia = false
  }

  async closeEncerrarPendenciaCloseModal() {
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    this.loadingCloseConfirmarEncerrarPendencia = true
    await this.orcamento.desbloquearSolicitacao(solicitacaoId)
    this.closeModalPendencia()
  }

  async closeModalPendencia() {
    await timeoutDefault()
    this.showModalPendencia = false
    this.showModalConfirmarEncerrarPendencia = false

    this.loadingCloseConfirmarEncerrarPendencia = false
    this.loadingEncerrarPendencia = false
    this.getDisplayPendencia = {
      nomePaciente: '',
      nomeMedico: '',
    }
    this.getPendenciaStore.clearPendencia()
  }

  async openFlowModal(agendamentoCirurgia: AgendamentoCirurgia | Solicitacao) {
    const response = await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoCirurgia.id)
    if (response.success) {
      switch (this.getBackofficeGlobalStore.solicitacao.situacao.key) {
        case 'AguardandoOrcamento':
          await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
          this.getBackofficeGlobalStore.setModal({ name: 'orcamento', value: true })
          this.ga('backoffice-orcamento', agendamentoCirurgia.acoes.orcamentoEnviaOrcamento ? 'enviar-orcamento' : 'atualizar-orcamento')
          break

        case 'AguardandoAprovacaoOrcamento':
          await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
          this.getBackofficeGlobalStore.setModal({ name: 'orcamento', value: true })
          this.ga('backoffice-orcamento', agendamentoCirurgia.acoes.orcamentoEnviaOrcamento ? 'enviar-orcamento' : 'atualizar-orcamento')
          break

        default:
          EventBus.$emit('setSnackbar', { show: true, text: 'Pendência encerrada com sucesso.', icon: 'done', color: '#2E7D32' })
          this.getBackofficeGlobalStore.setBackofficeArea(backofficeRoute())
          this.$router.push({ name: 'backoffice-surgery-solicitation-details', params: { solicitacaoId: agendamentoCirurgia.id } })
          break
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }
  }
  /**
   *****************************************
   * FIM Pendência
   *****************************************
   */

  loadAllSolicitacoes: boolean = false

  get loadingAllSolicitacoes() { return this.loadAllSolicitacoes }
  set loadingAllSolicitacoes(value: boolean) { this.loadAllSolicitacoes = value }

  async getAllBackofficeSolicitacoes() {
    this.loadingAllSolicitacoes = true
    const response = await this.getBackofficeOrcamentoStore.loadAgendamentosMedicoSearch()
    if (!response.success) EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
    this.loadingAllSolicitacoes = false
  }

  beforeDestroy() {
    this.getBackofficeOrcamentoStore.clearMotivosCancelamento()
    this.getBackofficeOrcamentoStore.clearMotivoCancelamentoId()
    this.getBackofficeOrcamentoStore.clearOrcamentoId()
    this.getBackofficeOrcamentoStore.setShowModalCancelamento(false)
    this.getBackofficeOrcamentoStore.clearFiltro()
    this.getBackofficeOrcamentoStore.setFilterOn(false)
    this.getBackofficeOrcamentoStore.setTodosOsStatus(false)
    this.getBackofficeOrcamentoStore.setTodosOsStatusDaArea(false)
    this.getBackofficeOrcamentoStore.resetSituacoes()
    this.getBackofficeGlobalStore.setBackofficeArea('')
  }

  created() {
    window.addEventListener('keydown', this.keyboardShortCuts)
  }

  destroyed() {
    window.removeEventListener('keydown', this.keyboardShortCuts)
  }

  keyboardShortCuts(event: KeyboardEvent) {
    if (event.ctrlKey && event.code === 'Space' && !!this.showAdvancedFilters) this.showAdvancedFilters()
    if (event.ctrlKey && event.altKey && event.code === 'Space' && !!this.clearAdvancedFilters) this.clearAdvancedFilters()
  }
}
